import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import pinia from './stores'
import '@/styles/index.scss'
import { useUserStore } from './stores/user.ts'

const browserTrackSDK = window["browserTrackSDK"];

const app = createApp(App)

app.use(pinia)
app.use(router)

// H5 调试面板：仅在开启 VITE_APP_DEBUG 的环境加载
if (import.meta.env.VITE_APP_DEBUG === 'true') {
  import('vconsole').then(({ default: VConsole }) => new VConsole())
}

const userStore = useUserStore()
console.log(userStore)

// 初始化sdk，并传入配置项
browserTrackSDK.init({
  project_id: "05-010",
  open_track_console:true
})
if(userStore.userInfo?.uid){
  browserTrackSDK.login(userStore.userInfo?.uid)
}

app.mount('#app')
